<script>
    import { alphabetStore } from '../../store/alphabet';

    import AlphabetItem from './alphabet-item.svelte';
    import TabsBar from '../tabs/tabs-bar.svelte';

    let letters = [];

    alphabetStore.subscribe(({ letters: lettersState }) => {
        letters = lettersState;
    });

</script>

<TabsBar>
    {#each letters as { letter, isActive }}
        <AlphabetItem {letter} {isActive} />
    {/each}
</TabsBar>

<style>
</style>
